"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventTypes;
(function (EventTypes) {
    EventTypes[EventTypes["Tradeshow"] = 0] = "Tradeshow";
})(EventTypes || (EventTypes = {}));
exports.default = EventTypes;
